"use strict"

function normalizeNode(node, parent = null) {
  return {
    [node.page.id]: {
      id: node.page.id,
      parent: parent !== null ? parent.page.id : null,
      siblings: parent !== null ? parent.children.map(c => c.page.id) : [],
      children: node.children.map(c => c.page.id),
    },
  }
}

// find parent, children and siblings
function resolveTree(tree, parent = null) {
  let result = {}

  for (let i = 0; i < tree.length; i++) {
    result = Object.assign(result, normalizeNode(tree[i], parent))

    if (tree[i].children.length > 0) {
      result = Object.assign(result, resolveTree(tree[i].children, tree[i]))
    }
  }

  return result
}

// find parent hierarchy for all items
function resolveHierarchy(allNodes) {
  for (let id in allNodes) {
    allNodes[id].parents = []

    let nodeParent = allNodes[id].parent

    while (nodeParent) {
      allNodes[id].parents.unshift(nodeParent)

      nodeParent = allNodes[nodeParent].parent
    }
  }

  return allNodes
}

function resolveCollectionTree(tree) {
  const result = resolveTree(tree)

  return resolveHierarchy(result)
}

module.exports = resolveCollectionTree
